module.exports = __webpack_public_path__ + "img/logo_Q_PlatformUI_W.2b7a2583.svg";